<div class="mb-24">
  <div class="title title--big">Регистрация сотрудника</div>
</div>

<app-users-create-edit-widget></app-users-create-edit-widget>
